import React from 'react'
import './App.css'
import {Provider} from 'react-redux'
import {store} from './store'
import CurrentPage from './components/CurrentPage'

function App() {
  return <Provider store={store}>
    <CurrentPage/>
  </Provider>
}

export default App
